import * as React from "react";
import type { SVGProps } from "react";
const SvgRewind = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m11 19-.614.79A1 1 0 0 0 12 19zm-9-7-.614-.79a1 1 0 0 0 0 1.58zm9-7h1a1 1 0 0 0-1.614-.79zm11 14-.614.79A1 1 0 0 0 23 19zm-9-7-.614-.79a1 1 0 0 0 0 1.58zm9-7h1a1 1 0 0 0-1.614-.79zM11.614 18.21l-9-7-1.228 1.58 9 7zm-9-5.42 9-7-1.228-1.58-9 7zM10 5v14h2V5zm12.614 13.21-9-7-1.228 1.58 9 7zm-9-5.42 9-7-1.228-1.58-9 7zM21 5v14h2V5z"
    />
  </svg>
);
export default SvgRewind;
